import { cn } from "@/lib/utils"

// One float skin for every surface that leaves the page (the design
// contract's "Surfaces"): a popover-colour panel, the standard border, the
// radius from the one knob (6px for what stands in front of the screens, 2px
// for what is anchored; DESIGN.md › Components › Surfaces). Surfaces that float free of an anchor (dialogs, menus,
// tooltips) carry the one tooltip shadow; surfaces anchored to a control
// (filter popovers, address suggestions) sit flush with no shadow. Portaled
// surfaces still stamp data-terminal-theme on themselves.
const surfaceBase = "bg-popover border-border text-foreground rounded-sm border"

export const terminalFloatClassName = cn(surfaceBase, "shadow-tooltip")
export const terminalAnchoredClassName = cn(surfaceBase, "shadow-none")

// A dialog: the float skin, one measure, the title in the title role and
// the description in the small prose role, 20px between its parts.
// A dialog sits on the screen's own surface, not a new colour, so its
// controls keep the contrast they have on the page; the scrim does the
// separating.
// A dialog is a screen in front of the screens, so it rounds like one and
// carries the live cyan edge and glow (Dhanur, 24 Oct 2026).
export const terminalDialogClassName = cn(
  terminalFloatClassName,
  "bg-background border-terminal-accent/55 shadow-(--terminal-glow) max-w-md gap-(--terminal-space-dialog) rounded-lg p-6"
)
// The subject's rule, as the page masthead draws it under the name.
export const terminalDialogSubjectRuleClassName =
  "border-border-strong border-t"
// A dialog is a screen in front of the screens, so its title is a view's
// title, on the title rung (Dhanur, 25 Oct 2026). text-xl pairs with
// type-title so the primitive's own text-lg is dropped by tailwind-merge.
export const terminalDialogTitleClassName =
  "type-title text-xl leading-6 tracking-normal pr-8"

// A menu: the float skin with 4px of inset, rounded like a dialog since it
// too stands in front of the screens (Dhanur, 25 Oct); each item is a
// body-size row with the bounded hover fill.
export const terminalMenuClassName = cn(
  terminalFloatClassName,
  "min-w-52 rounded-lg p-1"
)
export const terminalMenuItemClassName =
  "type-nav text-foreground focus:bg-accent focus:text-foreground data-[selected=true]:bg-accent flex cursor-pointer items-center justify-between gap-4 rounded-sm px-2.5 py-2"
